var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 43,
    viewBox: "0 0 178 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1327 1L35.2655 11.1239V32.1504L18.1327 41.885L1 30.9823V11.1239L18.1327 1Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.1239L18.1327 21.2478M1 11.1239L18.1327 1L35.2655 11.1239M1 11.1239V30.9823L18.1327 41.885M18.1327 21.2478L35.2655 11.1239M18.1327 21.2478V41.885M35.2655 11.1239V32.1504L18.1327 41.885",
    stroke: "#0E8080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94618 12.7974L6.05729 11.0075L18.2282 3.42724L21.1171 5.21711L8.94618 12.7974Z",
    fill: "#0E8080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4908 15.7186L10.6019 13.9287L22.7728 6.34838L25.6617 8.13826L13.4908 15.7186Z",
    fill: "#0E8080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.232 18.7281L15.3431 16.9382L27.514 9.35791L30.4029 11.1478L18.232 18.7281Z",
    fill: "#0E8080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7168 14.8762V9.92041H60.4071V14.8762H53.5929V32.5753H47.531V14.8762H40.7168ZM66.9932 32.5753H60.3561L67.8339 9.92041H76.241L83.7189 32.5753H77.0817L72.126 16.1593H71.949L66.9932 32.5753ZM65.7543 23.6372H78.2322V28.239H65.7543V23.6372ZM87.1469 32.5753V9.92041H93.2973V27.6195H102.457V32.5753H87.1469ZM106.189 32.5753V9.92041H112.339V19.0797H112.649L119.463 9.92041H126.631L118.976 20.0089L126.808 32.5753H119.463L114.375 24.0797L112.339 26.7346V32.5753H106.189Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.861 32.5753H129.145V9.92041H137.773C140.103 9.92041 142.117 10.374 143.813 11.281C145.516 12.1807 146.829 13.4787 147.751 15.1748C148.68 16.8636 149.145 18.888 149.145 21.2478C149.145 23.6077 148.684 25.6358 147.762 27.3319C146.84 29.0207 145.535 30.3186 143.846 31.2257C142.157 32.1254 140.162 32.5753 137.861 32.5753ZM135.295 27.354H137.64C138.761 27.354 139.716 27.1734 140.505 26.812C141.302 26.4506 141.906 25.8275 142.319 24.9425C142.74 24.0576 142.95 22.826 142.95 21.2478C142.95 19.6697 142.736 18.4381 142.308 17.5532C141.888 16.6682 141.269 16.045 140.45 15.6837C139.639 15.3223 138.643 15.1416 137.463 15.1416H135.295V27.354Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.481 9.56641H168.614V15.2057H151.481V9.56641Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.481 18.4282H168.614V24.0675H151.481V18.4282Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.481 27.2899H168.614V32.9292H151.481V27.2899Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.1 9.92041V32.5753H170.95V9.92041H177.1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.6f08addd696bb979471db33ba61d404c.svg";
export { ForwardRef as ReactComponent };